import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useHistory } from 'react-router-dom';

function HistoryBack(props) {
	const { t } = useTranslation();
	const theme = useTheme();
	const history = useHistory();

	return (
		<div
			style={{
				display: 'inline-flex',
				marginBottom: theme.spacing(2),
				alignItems: 'center',
				cursor: 'pointer',
			}}
			onClick={() => {
				history.goBack();
			}}
		>
			<ArrowBackIcon
				fontSize="inherit"
				style={{
					color: theme.palette.link,
					marginRight: theme.spacing(0.5),
				}}
			/>
			<Link color="initial" variant="body1">
				{t('help_screen.back')}
			</Link>
		</div>
	);
}

export default HistoryBack;
